import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CouponService } from 'app/core/services/coupon.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { FieldTypes } from 'app/shared/model/enums';
import { CommonService } from 'app/shared/services/common.service';
import { AdvMessageService } from 'app/shared/services/message.service';
import { BaseBusinessCoupon } from '../base-businessCoupon';

@Component({
  selector: 'app-business-coupons',
  templateUrl: './business-coupons.component.html',
  styleUrl: './business-coupons.component.scss'
})
export class BusinessCouponsComponent extends BaseBusinessCoupon implements OnInit, AfterViewInit {
  @ViewChild('resendEmailTemplate') resendEmailTemplate: TemplateRef<any>;
  constructor(public localizationService: LocalizationService, public commonService: CommonService, public couponService: CouponService, public messageService: AdvMessageService) {
    super(couponService, localizationService, commonService, messageService)
  }
  ngOnInit(): void {
    this.init()
    this.columns = [...this.columns, {
      field: 'resendEmail',
      headerTranslate: 'BUSINESS_COUPON.RESEND_EMAIL',
      type: FieldTypes.template,
      sortable: false
    }];
  }
  ngAfterViewInit(): void {
    const resendColumn = this.columns.find(col => col.field === 'resendEmail');
    if (resendColumn) {
      resendColumn.outletTemplate = this.resendEmailTemplate;
    }
  }
  onLoadData(event) {
    this.request.Paging = event.Paging;
    this.loadBusinessCoupons();
  }

}
